import { ChatEvents } from '@apparel/core/chat';
import { ChatService } from '@apparel/core/chat/ChatService';
import { ChatMessage } from '@apparel/core/models/ChatMessage';
import { useChatContext } from '@apparel/react/Chat/ChatProvider';
import useNotify from '@hooks/useNotify';
import { useEffect, useRef } from 'react';

export const ChatNotifications = () => {
    const chat = useChatContext();
    const notify = useNotify();
    const activeRoomId = useRef(chat.get('room_id'));
    const opened = useRef({});

    useEffect(() => {
        let off = () => null;

        if (chat.get('connected')) {
            off = ChatService.getInstance().on(ChatEvents.NEW_MESSAGE, (message: ChatMessage) => {
                if (message.room_id && message.room_id !== activeRoomId.current && !opened.current[message.room_id]) {
                    const room = chat.getRoom(message.room_id);
                    if (room?.unread_messages > 0) {
                        const members = room?.getMembers()?.join(', ') ?? '';
                        opened.current[message.room_id] = true;
                        // noinspection JSIgnoredPromiseFromCall
                        notify.info(`You have new messages on your conversation with ${members}`, {
                            onExited: () => (opened.current[message.room_id] = false),
                        });
                    }
                }
            });
        }

        return () => {
            off();
        };
    }, [chat.get('connected'), chat.hashCode()]);

    return null;
};
